<template>
    <div style="border: 1px solid #ccc" class="relative" v-loading="loading">
        <div v-if="disabled" class="disable-layer" />
        <Toolbar ref="toolbar" style="border-bottom: 1px solid #ccc" :editor="editor" :default-config="toolbarConfig"
            :mode="mode" />
        <Editor style="overflow-y: hidden" :value="value" :default-config="editorConfig" :mode="mode"
            @input="handleInput" @onCreated="onCreated" />
    </div>
</template>

<script>
// 引入包
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { Boot } from '@wangeditor/editor'
// 上传文件的接口
import videoApi, { uploadUrl } from './VideoApi'
// 引入wangeditor/editor-for-vue的样式
import '@wangeditor/editor/dist/css/style.css'


import FormatPaint, { withSelect } from './wangeditorGeShiShua.js'


//获取当前时间戳
const timestamp = Date.now()
// 生成一个随机数
const randomNum = Math.floor(Math.random() * 1000000) // 生成一个0到999999之间的随机数
// 将时间戳和随机数组合成一个字符串作为格式刷key
let geShiShuaKey = `${timestamp}-${randomNum}`
const FormatPaintMenuConf = {
  key: geShiShuaKey, // 定义 menu key ：要保证唯一、不重复（重要）
  factory() {
    return new FormatPaint() // 把 `YourMenuClass` 替换为你菜单的 class
  }
}
Boot.registerMenu(FormatPaintMenuConf)
Boot.registerPlugin(withSelect)

export default {
    name: 'WangEditor',
    components: { Editor, Toolbar },
    props: {
        value: String,
        disabled: Boolean,
        cusHeight: {
            type: String,
            default: '150px'
        }
    },
    data() {
        return {
            loading: false,
            editor: null,
            html: '',
            // wangeditor/editor-for-vue的配置
            toolbarConfig: {
                toolbarKeys: [
                    geShiShuaKey,
                    'bold',
                    'underline',
                    'italic',
                    'through',
                    'clearStyle',
                    'color',
                    'bgColor',
                    'fontSize',
                    'justifyLeft',
                    'justifyRight',
                    'justifyCenter',
                    'justifyJustify',
                    'lineHeight',
                    'header1',
                    'header2',
                    'header3',
                    'header4',
                    'header5',
                    'bulletedList',
                    'numberedList',
                    'uploadImage',
                    "uploadVideo"
                ]
            },
            editorConfig: {
                placeholder: '请输入内容...',
                MENU_CONF: {
                }
            },
            mode: 'default' // or 'simple'
        }
    },
    mounted() { 
        
    },
    created() {
        let that = this;
        this.editorConfig.MENU_CONF = {
                    uploadImage: {
                        // 自定义图片上传
                        async customUpload(file, insertFn) {
                            const formData = new FormData()
                            formData.append('file', file)  // 'files' 是 API 中接受文件的字段名
                            that.loading = true;
                            videoApi.uploadImg(formData).then(response => {
                                that.loading = false;
                                if (response) {
                                    const url = uploadUrl + response.data.fileId
                                    // console.log(uploadUrl)
                                    // 将图片插入到文本框中
                                    insertFn(url)
                                }
                            })
                        }
                    },
                    uploadVideo: {
                        // 自定义图片上传
                        async customUpload(file, insertFn) {
                            const formData = new FormData()
                            formData.append('file', file)  // 'files' 是 API 中接受文件的字段名
                            that.loading = true;
                            videoApi.uploadImg(formData).then(response => {
                                that.loading = false;
                                if (response) {
                                    const url = uploadUrl + response.data.fileId
                                    // console.log(uploadUrl)
                                    // 将图片插入到文本框中
                                    insertFn(url)
                                }
                            })
                        }
                    }
                }
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
            // console.log('this.editor :>> ', this.editor.getAllMenuKeys());
        },
        handleInput(value) {
            const imgReg = /<img.*?src="(.*?)".*?alt="(.*?)".*?data-href="(.*?)".*?style="(.*?)".*?>/gi
            let result;
            while ((result = imgReg.exec(value))) {
                const style = result[4];
                if (!style.includes("width")) {
                    let img = `<img src="${result[1]}" alt="${result[2]}" data-href="${result[3]}" style="width:100%;${result[4]}" />`
                    value = value.replace(result[0], img);
                }
            }
            // console.log(value);
            const videoReg = /<video.*?poster="(.*?)".*?controls="(.*?)".*?width="(.*?)".*?height="(.*?)".*?>/gi
            while ((result = videoReg.exec(value))) {
                const width = result[3] == "auto" ? '100%' : result[3];
                const height = result[4] == "auto" ? '100%' : result[4];
                let video = `<video poster="${result[1]}" controls="${result[2]}" width="${result[3]}" height="${result[4]}" style="width:${width}; height:${height};">`
                value = value.replace(result[0], video);
            }
            var elements = document.getElementsByTagName("video");
            // console.log(elements);
            if (elements.length > 0) {
                for (let i = 0; i < elements.length; i ++) {
                    let element = elements[i];
                    if (element.width  == 0) {
                        element.style.width = '100%';
                    }
                    if (element.height == 0) {
                        element.style.height = '100%';
                    }
                }

            }
            // console.log(value);
            // 将文本内容传给父组件（引用这个组件的vue文件的）
            this.$emit('input', value)
        }
    }
}
</script>

<style lang="scss" scoped>
.disable-layer {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    opacity: 0.5;
}
video {
    max-width: 100%;
    width: 100%;
}
</style>